import React, { useState } from 'react';

export default function OrganizationsSelector({
  options = [],
  selected = [],
  onChange,
  error,
  label = 'Organizations',
  required = false,
  defaultOpen = false,
  testId
}) {
  const [open, setOpen] = useState(defaultOpen);
  const names = (options || [])
    .filter(Boolean)
    .map((o) => (typeof o === 'string' ? o : (o?.name || '')))
    .filter(Boolean);
  const allSelected = selected.length === names.length;
  const countLabel = allSelected ? 'All organizations selected' : `${selected.length} selected`;

  const toggle = (name) => {
    const exists = selected.includes(name);
    const next = exists ? selected.filter((n) => n !== name) : [...selected, name];
    onChange(next);
  };

  const selectAll = () => onChange(names);
  const selectNone = () => onChange([]);

  const sanitize = (value) => String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');

  return (
    <div className="field full-span" data-testid={testId || undefined}>
      <div className="collapse-header">
        <div>
          <label className="label">
            {label} {required && <span className="required-dot" aria-label="required">*</span>}
          </label>
          <div className="muted" style={{ marginTop: 2 }} data-testid={testId ? `${testId}-count` : undefined}>{countLabel}</div>
        </div>
        <button type="button" className="subtle-btn" onClick={() => setOpen((v) => !v)} data-testid={testId ? `${testId}-toggle` : undefined}>
          {open ? 'Hide' : 'Edit'}
        </button>
      </div>
      {open && (
        <>
          <div className="chip-actions">
            <button type="button" className="subtle-btn" onClick={selectAll} data-testid={testId ? `${testId}-select-all` : undefined}>Select All</button>
            <button type="button" className="subtle-btn" onClick={selectNone} data-testid={testId ? `${testId}-select-none` : undefined}>Select None</button>
          </div>
          <div className={`chip-group ${error ? 'error' : ''}`} data-testid={testId ? `${testId}-chips` : undefined}>
            {names.map((n) => {
              const active = selected.includes(n);
              return (
                <button
                  key={n}
                  type="button"
                  className={`chip ${active ? 'active' : ''}`}
                  onClick={() => toggle(n)}
                  aria-pressed={active}
                  data-testid={testId ? `${testId}-chip-${sanitize(n)}` : undefined}
                >
                  {n}
                </button>
              );
            })}
          </div>
        </>
      )}
      {error && <div className="error-text" data-testid={testId ? `${testId}-error` : undefined}>{error}</div>}
    </div>
  );
}
